import { Point } from '../../../common/maths/geometry/pointTypes';

export const TIPTAP_MOUNT_POINT_NAME = 'tiptap-popup-mount-point';

export const getTiptapPortalMountPoint = () => document.getElementById(TIPTAP_MOUNT_POINT_NAME);

export type PopupPosition = {
    anchor: 'top' | 'bottom';
    point: Point;
};
